export default "__VITE_ASSET__Dcd1VpO5__"